import { Role, type RoleRepository } from '@telespot/domain';
import { ParseBaseRepository } from '../../parse-base.repository';
import { ParseRoleMapper, RoleTopology } from './parse-role.mapper';
import { ObjectTopology } from '../../parse.topology';

export class ParseRoleRepository extends ParseBaseRepository implements RoleRepository {
  private readonly mapper = new ParseRoleMapper(this.parse);

  public async getUserRoles(userId: string): Promise<Role[]> {
    const parseRoles = await new this.parse.Query(this.parse.Role)
      .containedIn('users', [this.parse.User.createWithoutData(userId)])
      .find(this.options);

    return parseRoles.map((pr) => this.mapper.toDomain(pr));
  }

  public async getUserIdsInRole(roleName: string): Promise<string[]> {
    const parseRole = await new this.parse.Query(this.parse.Role)
      .equalTo(RoleTopology.NAME, roleName)
      .first(this.options);

    if (!parseRole) return [];

    const users = await parseRole.getUsers().query().find(this.options);

    return users.map((user) => user.id);
  }

  public async list(): Promise<Role[]> {
    const parseRoles = await new this.parse.Query(this.parse.Role).descending(ObjectTopology.ID).find(this.options);
    return parseRoles.map((pr) => this.mapper.toDomain(pr));
  }

  public async save(roles: Role[]): Promise<void> {
    const parseRoles = roles.map((pr) => this.mapper.fromDomain(pr));
    await this.parse.Role.saveAll(parseRoles, this.options);
  }
}
